import { jsx as a, jsxs as u } from "react/jsx-runtime";
import { withRipple as _ } from "@rmwc/ripple";
import { Button as l } from "@rmwc/button";
import { IconButton as C } from "@rmwc/icon-button";
import { createComponent as o, useClassNames as r, Tag as e } from "@rmwc/base";
const x = o(function(c, n) {
  const { outlined: t, ...i } = c, s = r(c, [
    "mdc-card",
    {
      "mdc-card--outlined": t
    }
  ]);
  return /* @__PURE__ */ a(e, { ...i, ref: n, className: s });
}), y = o(
  function(c, n) {
    const { square: t, sixteenByNine: i, ...s } = c, m = r(c, [
      "mdc-card__media",
      {
        "mdc-card__media--square": t,
        "mdc-card__media--16-9": i
      }
    ]);
    return /* @__PURE__ */ a(e, { tag: "section", ...s, ref: n, className: m });
  }
), b = o(
  function(c, n) {
    const t = r(c, ["mdc-card__media-content"]);
    return /* @__PURE__ */ a(e, { ...c, ref: n, className: t });
  }
), M = _({
  surface: !1
})(
  o(
    function(c, n) {
      const t = r(c, ["mdc-card__primary-action"]), { children: i, ...s } = c;
      return /* @__PURE__ */ u(e, { ...s, ref: n, className: t, children: [
        i,
        /* @__PURE__ */ a("div", { className: "mdc-card__ripple" })
      ] });
    }
  )
), g = o(
  function(c, n) {
    const { fullBleed: t, ...i } = c, s = r(c, [
      "mdc-card__actions",
      { "mdc-card__actions--full-bleed": t }
    ]);
    return /* @__PURE__ */ a(e, { tag: "div", ...i, ref: n, className: s });
  }
), h = o(
  function(c, n) {
    const t = r(c, ["mdc-card__action-buttons"]);
    return /* @__PURE__ */ a(e, { ...c, ref: n, className: t });
  }
), j = o(
  function(c, n) {
    const t = r(c, ["mdc-card__action-icons"]);
    return /* @__PURE__ */ a(e, { ...c, ref: n, className: t });
  }
), q = o(
  function(c, n) {
    const t = r(c, [
      "mdc-card__action",
      "mdc-card__action--icon",
      "mdc-icon-button--display-flex"
    ]);
    return /* @__PURE__ */ a(C, { ...c, ref: n, className: t });
  }
), v = o(
  function(c, n) {
    const t = r(c, [
      "mdc-card__action",
      "mdc-card__action--button"
    ]);
    return /* @__PURE__ */ a(l, { ...c, ref: n, className: t });
  }
);
export {
  x as Card,
  v as CardActionButton,
  h as CardActionButtons,
  q as CardActionIcon,
  j as CardActionIcons,
  g as CardActions,
  y as CardMedia,
  b as CardMediaContent,
  M as CardPrimaryAction
};
